<div class="container py-5 login-page-container">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">

      <div class="text-center mb-4 mt-6 pt-5">
        <h1 class="mat-display-1 fw-bold" style="color: #215DAB">Reset Password</h1>
        <p class="mat-subheading-2 text-secondary">Choose a new password for your account</p>
      </div>

      <mat-card class="p-4 shadow-lg rounded" style="background-color: #f8faff;">
        <mat-card-content>
          <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate" diameter="40">
          </mat-progress-spinner>

          <app-success-message [message]="this.successMessage"></app-success-message>
          <app-error-message [message]="this.errorMessage"></app-error-message>

          <!-- Form -->
          <form *ngIf="!successMessage" (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
            <div class="mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>New password</mat-label>
                <input
                  type="password"
                  name="new_pass"
                  required
                  minlength="8"
                  matInput
                  ngModel>
                <mat-icon matPrefix class="text-secondary me-2">lock</mat-icon>
                <mat-error *ngIf="f.controls['new_pass']?.invalid && f.controls['new_pass']?.touched">
                  Password must be at least 8 characters
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Confirm new password</mat-label>
                <input
                  type="password"
                  name="confirm_pass"
                  required
                  minlength="8"
                  matInput
                  ngModel>
                <mat-icon matPrefix class="text-secondary me-2">lock_outline</mat-icon>
                <mat-error *ngIf="f.controls['confirm_pass']?.invalid && f.controls['confirm_pass']?.touched">
                  Please confirm your new password
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-grid gap-2">
              <button
                [disabled]="!f.valid"
                type="submit"
                mat-raised-button
                color="primary"
                class="py-2">
                <span class="d-flex align-items-center justify-content-center">
                  <mat-icon class="me-2">lock_reset</mat-icon>
                  <span>Reset Password</span>
                </span>
              </button>
            </div>

            <div class="mt-3 text-center">
              <a mat-button routerLink="/auth/forgot-password" color="accent">Request a New Link</a>
            </div>
          </form>

          <!-- Confirmation -->
          <div *ngIf="successMessage" class="text-center">
            <a mat-raised-button color="primary" class="py-2" routerLink="/auth/login">
              <span class="d-flex align-items-center justify-content-center">
                <mat-icon class="me-2">login</mat-icon>
                <span>Sign In</span>
              </span>
            </a>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
